import { isPlatformBrowser } from '@angular/common'
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http'
import { PLATFORM_ID, inject } from '@angular/core'
import { Router } from '@angular/router'
import { Observable, catchError, throwError } from 'rxjs'

export const AuthInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router)
  const platformId = inject(PLATFORM_ID)
  const TOKEN_KEY = 'JWT_TOKEN'

  if (request.url.includes('/auth/login') || request.url.includes('/auth/register')) {
    console.log('⚪ Petición de autenticación - No se requiere token')
    return next(request)
  }

  let token: string | null = null
  if (isPlatformBrowser(platformId)) {
    token = localStorage.getItem(TOKEN_KEY)
  }

  if (!token) {
    console.warn('⚠️ No se encontró token - Petición sin autorización')
    return next(request)
  }

  if (!token.includes('.')) {
    console.error('❌ Error: Token inválido - No es un JWT válido')
    if (isPlatformBrowser(platformId)) {
      router.navigate(['/login'])
    }
    return throwError(() => new Error('Token inválido'))
  }

  try {
    const modifiedRequest = request.clone({
      withCredentials: false,
      setHeaders: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        ...(!(request.body instanceof FormData) && {
          'Content-Type': 'application/json',
        }),
      },
    })

    const _headers = modifiedRequest.headers

    return next(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('❌ Error en la petición:', {
          url: request.url,
          status: error.status,
          statusText: error.statusText,
          error: error.error,
        })

        if (error.status === 401) {
          console.error('🚨 Error 401: Token inválido o expirado')
          if (isPlatformBrowser(platformId)) {
            localStorage.removeItem(TOKEN_KEY)
            router.navigate(['/login'])
          }
        }

        return throwError(() => error)
      }),
    )
  } catch (error) {
    console.error('❌ Error procesando la petición:', error)
    return throwError(() => error)
  }
}
